@if (environment.environment !== 'prod') {
    <mat-toolbar [attr.environment]="environment.environment">
        <mat-toolbar-row>
            {{ environment.environment.toUpperCase() }}
        </mat-toolbar-row>
    </mat-toolbar>
}
